import React from 'react';
import { Shirt, Wallet, Infinity as InfinityIcon, Clock } from 'lucide-react';
export function SummerCampKeyInfo() {
  return <section className="py-16 bg-paper border-b border-subtle-gray" data-id="element-3238">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3239">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3240">
          <div className="bg-off-white p-6 rounded-2xl border border-subtle-gray" data-id="element-3241">
            <Shirt className="w-8 h-8 text-storm-red mb-3" data-id="element-3242" />
            <h3 className="text-lg text-ink mb-1" data-id="element-3243">Camp Shirt Included</h3>
            <p className="text-gray-warm text-sm" data-id="element-3244">
              Every camper gets an official Storm Taekwondo shirt.
            </p>
          </div>
          <div className="bg-off-white p-6 rounded-2xl border border-subtle-gray" data-id="element-3245">
            <Wallet className="w-8 h-8 text-storm-red mb-3" data-id="element-3246" />
            <h3 className="text-lg text-ink mb-1" data-id="element-3247">Flexible Payment</h3>
            <p className="text-gray-warm text-sm" data-id="element-3248">
              Pay one week at a time, or ask about paying by the day.
            </p>
          </div>
          <div className="bg-off-white p-6 rounded-2xl border border-subtle-gray" data-id="element-3249">
            <InfinityIcon className="w-8 h-8 text-storm-red mb-3" data-id="element-3250" />
            <h3 className="text-lg text-ink mb-1" data-id="element-3251">No Capacity Limit</h3>
            <p className="text-gray-warm text-sm" data-id="element-3252">
              If more campers sign up, more helpers are added.
            </p>
          </div>
          <div className="bg-off-white p-6 rounded-2xl border border-subtle-gray" data-id="element-3253">
            <Clock className="w-8 h-8 text-storm-red mb-3" data-id="element-3254" />
            <h3 className="text-lg text-ink mb-1" data-id="element-3255">Late Pickup OK</h3>
            <p className="text-gray-warm text-sm" data-id="element-3256">
              Kids can hang out. Regular classes start right after camp.
            </p>
          </div>
        </div>
      </div>
    </section>;
}